export var FeedTag;
(function (FeedTag) {
    FeedTag["Promotion"] = "promotion";
})(FeedTag || (FeedTag = {}));
